import { render, staticRenderFns } from "./UnitPlanTextField.vue?vue&type=template&id=2fdbef80&scoped=true&"
import script from "./UnitPlanTextField.vue?vue&type=script&lang=js&"
export * from "./UnitPlanTextField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdbef80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/c/Users/wbreu/Documents/code/personal/the-unit-planner/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2fdbef80', component.options)
    } else {
      api.reload('2fdbef80', component.options)
    }
    module.hot.accept("./UnitPlanTextField.vue?vue&type=template&id=2fdbef80&scoped=true&", function () {
      api.rerender('2fdbef80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UnitPlanTextField.vue"
export default component.exports